{
  "assetDisplay.mapengine": {
    "fEnableOSM": true,
    "fEnableS57": true,
    "fEnableGSAT": false,
    "fEnableS57OpenGL": false,
    "enableUserSpecificS57": true,
    "osmBaseName": "OSM-EN",
    "osmBaseUrl": "https://maptiles.p.rapidapi.com/en/map/v1",
    "osmHeaders": [
      "X-RapidAPI-Key=4e7abe5790msh8641838f6d33026p104cc3jsna5ad7a101f8d"
    ],
    "viewParam": {
      "center": {
        "lat": 56,
        "lon": 11
      },
      "zoomLevel": 6
    }
  },
  "ribbonPlugin.settings": {
    "filter_color_inside": "00FF00",
    "filter_color_outside": "FFFF00",
    "label_zoom_level_filter": 9,
    "label_zoom_level_nofilter": 9,
    "locale": "en_US",
    "target_timeouts": [
      {
        "dst": 0,
        "lost": 7,
        "deleted": 14
      },
      {
        "dst": 1,
        "lost": 7,
        "deleted": 14
      },
      {
        "dst": 2,
        "lost": 360,
        "deleted": 720
      },
      {
        "dst": 3,
        "lost": 720,
        "deleted": 1440
      },
      {
        "dst": 4,
        "lost": 7,
        "deleted": 14
      },
      {
        "dst": 6,
        "lost": 360,
        "deleted": 720
      },
      {
        "dst": 7,
        "lost": 360,
        "deleted": 720
      },
      {
        "dst": 8,
        "lost": 7,
        "deleted": 14
      },
      {
        "dst": 9,
        "lost": 7,
        "deleted": 14
      },
      {
        "dst": 10,
        "lost": 7,
        "deleted": 14
      },
      {
        "dst": 11,
        "lost": 7,
        "deleted": 14
      },
      {
        "dst": 12,
        "lost": 7,
        "deleted": 14
      }
    ],
    "time_format": "H:i",
    "tz_abbrev": "UTC",
    "tz_name": "Etc/UTC",
    "graticule_on": false,
    "realtime_data_on": true,
    "scale_on": true,
    "shapelabels_on": true,
    "auto_refresh_enabled": true,
    "show_refresh_indicator": false,
    "ship_color_state": "LegendShipType",
    "ship_color_noshow_sel": [],
    "enable_legend": true,
    "legend_collapsed": false,
    "legend_age_intervals": null,
    "legend_age_intervalsize": null,
    "legend_age_intervalunit": null,
    "anim_pos_ind_color": "00FFFF",
    "selection_ind_color": "00FF00",
    "ship_moving_symbol": "Ship",
    "ship_not_moving_symbol": "Ship",
    "ship_moving_threshold": 0.1,
    "track_show_samples": false,
    "track_show_dir": false,
    "track_connect_all": false,
    "track_timestamp_interval": 60,
    "track_max_pos_jump": 0,
    "track_max_speed": 0,
    "track_selected_target": false,
    "target_scale": "100",
    "enable_history": true,
    "track_lookback_time": 120,
    "predictor_time": 360,
    "sog_time": null,
    "default_tab": null,
    "remotecontrol_enabled": false,
    "emergency_alerts": true,
    "font_size": 12,
    "length_unit": "Nm",
    "target_card_expanded_by_default": false,
    "favorite_fields": ["name", "shipType", "destination", "speedOverGround"],
    "target_header_field": "name",
    "target_subtitle_field": "callSign",
    "speed_unit": "kn",
    "temp_unit": "C",
    "show_satellites": true,
    "show_satellite_footprints": "always",
    "satellite_transparency": 0,
    "satellite_lookback": 0,
    "satellite_lookahead": 0,
    "date_format": "d M Y",
    "export_utc": false,
    "pos_format": "DM",
    "shape_show_metadata": false,
    "enable_audio_alarm": false,
    "enable_replay_interpolation": true,
    "active_wms_base_layers": [],
    "ribbonInitState": {
      "mapview": "TARGET_INFO"
    },
    "show_label_mmsi": false,
    "show_label_name": true,
    "show_label_callsign": false,
    "show_label_imo": true,
    "show_label_shiptype": false,
    "show_label_cargotype": false,
    "show_label_country": false,
    "show_label_destination": false,
    "show_label_size": false,
    "show_label_sog": false,
    "show_label_cog": false,
    "show_label_heading": false,
    "show_label_draught": false,
    "show_label_navstatus": false,
    "show_label_methyd": false,
    "show_label_driver": false,
    "show_popup_mmsi": false,
    "show_popup_name": true,
    "show_popup_callsign": false,
    "show_popup_imo": true,
    "show_popup_shiptype": false,
    "show_popup_cargotype": false,
    "show_popup_country": false,
    "show_popup_flag": false,
    "show_popup_destination": false,
    "show_popup_size": false,
    "show_popup_sog": false,
    "show_popup_cog": false,
    "show_popup_heading": false,
    "show_popup_draught": false,
    "show_popup_navstatus": false,
    "show_popup_methyd": false,
    "show_popup_driver": false,
    "active_layer": "OSM-EN",
    "charttype_collapsed": false,
    "emergency_area": null,
    "filter_only_match": true,
    "filter_active": null,
    "filter_checked": [],
    "filter_show_only_mine": false,
    "filter_show_only_sharegroup": "NONE",
    "filter_legend_collapsed": true,
    "auto_create_shiplist": false,
    "enable_auto_filter": false,
    "favorite_shapes": {
      "shapes": [],
      "enabled": false,
      "transparency": 0
    },
    "show_wd_toast_for": 4,
    "remove_wd_after": 12,
    "report_show_legend": true,
    "report_show_boundary": true,
    "report_show_job_details": true,
    "report_sort_key": "tplName",
    "report_sort_dir": "ASC",
    "report_show_only_mine": false,
    "report_show_only_sharegroup": "NONE",
    "report_ship_stopped_speed": 1,
    "report_export_all": true,
    "report_exclude_all_non_vessels": true,
    "port_user_ports": [],
    "port_quay_eq_color": "FFFFCE",
    "port_quay_ueq_color": "00CE64",
    "port_arrival_lookahead": 0,
    "port_last_selected": null,
    "show_calc_ship_track": false,
    "port_show_erp_widget": true,
    "pilot_user_locs": [],
    "pilot_loc_last_selected": null,
    "pilot_grid_cfg": {
      "src_name": {
        "width": 130,
        "hidden": false
      },
      "src_shiptype": {
        "width": 100,
        "hidden": false
      },
      "src_imo": {
        "width": 60,
        "hidden": false
      },
      "src_draught": {
        "width": 75,
        "hidden": false
      },
      "src_destination": {
        "width": 130,
        "hidden": false
      },
      "src_length": {
        "width": 90,
        "hidden": false
      },
      "src_width": {
        "width": 90,
        "hidden": false
      },
      "eta_ts": {
        "width": 120,
        "hidden": false
      },
      "message_sort": {
        "width": 30,
        "hidden": false
      },
      "warpcolor": {
        "width": 30,
        "hidden": false
      }
    },
    "show_wms_track_layer": false,
    "tracks_show_portcalls": false,
    "tracks_color_sog": false,
    "msg_lookback_hours": 24,
    "msg_area_of_interest": null,
    "enable_wms": false,
    "wms_legend_collapsed": true
  },
  "wmsSettings": [],
  "vectorTiles": [],
  "bookmarks": []
}
